/*
 * Copyright (c) 2022. Nedaware SL
 */

/**
 * Nedaware S.L.
 * @author David Campos Rodríguez <david.campos.r96@gmail.com>
 */

import {InternalPropertyMap} from "../basic-entity-back/basic-entity-interface/mapping-internal";
import {Type} from "@angular/core";

export type Filter = Type<FilterInterface>;

/**
 * This interface defines the methods all the filters should implement
 * for the basic entity filter manager to use them.
 */
export interface FilterInterface {
    /**
     * Receives the property the filter is applied to and the values it has been assigned (all of them as an array),
     * the filter will rely on the values to be accepted by the accepts function
     * @see accepts
     * @param property
     * @param data
     * @return the params as strings ready to send to the back-end
     */
    dataToParams(property: InternalPropertyMap | null, data: any[] | any): { [p: string]: string | string[] };
}

/**
 * Error to throw when an invalid value is passed into a filter
 */
export class InvalidFilterValue extends Error {
    constructor(value: any, message: string) {
        super(`Invalid value ${value} sent to the filter: ${message}`);
    }
}

/**
 * Error thrown when an invalid property is passed into a filter
 */
export class InvalidFilterProperty extends Error {
    constructor(property: InternalPropertyMap, message: string) {
        super(`Invalid property ${property ? property.modelKey : property} sent to the filter: ${message}`);
    }
}
